import { render, staticRenderFns } from "./foot-cart.vue?vue&type=template&id=22b81090&"
import script from "./foot-cart.vue?vue&type=script&lang=js&"
export * from "./foot-cart.vue?vue&type=script&lang=js&"
import style0 from "./foot-cart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports